import { render, staticRenderFns } from "./_Weekly.vue?vue&type=template&id=5719a54e&scoped=true&"
import script from "./_Weekly.vue?vue&type=script&lang=js&"
export * from "./_Weekly.vue?vue&type=script&lang=js&"
import style0 from "./_Weekly.vue?vue&type=style&index=0&id=5719a54e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5719a54e",
  null
  
)

export default component.exports